// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "电力系统分析",
      "tec": "姜兴宇钱小毅",
      "week": "1-14周",
      "add": "教学楼A座116电力"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "张洪涛",
        "week": "1-8周",
        "add": "教学楼A座118电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "张洪涛",
        "week": "9-10,14,16周",
        "add": "教学楼A座118电力"
      }
    ],
    0,
    0
  ],
  "2": [
    {
      "sub": "电力电子技术",
      "tec": "田卫华尹常永",
      "week": "1-14,16周",
      "add": "教学楼A座219电力"
    },
    0,
    {
      "sub": "自动控制原理",
      "tec": "马艺骅",
      "week": "1-14周",
      "add": "教学楼C座110教务"
    },
    0,
    {
      "sub": "就业创业指导",
      "tec": "赵毅王刚王祎雪刘东岩",
      "week": "9-12周",
      "add": "大活礼堂"
    }
  ],
  "3": [
    {
      "sub": "电力系统分析",
      "tec": "姜兴宇钱小毅",
      "week": "1-14周",
      "add": "教学楼A座116电力"
    },
    0,
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "电力系统分析",
      "tec": "姜兴宇钱小毅",
      "week": "1-14周",
      "add": "教学楼C座110教务"
    },
    {
      "sub": "电力电子技术",
      "tec": "田卫华尹常永",
      "week": "1-9周",
      "add": "教学楼A座226电力"
    },
    0,
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "张洪涛",
        "week": "1-8周",
        "add": "教学楼C座113教务"
      },
      {
        "sub": "国家安全教育",
        "tec": "张洪涛",
        "week": "9-10,14,16周",
        "add": "教学楼C座113教务"
      }
    ],
    0
  ],
  "5": [
    {
      "sub": "工程伦理",
      "tec": "李震金钰",
      "week": "1-8周",
      "add": "教学楼C座110教务"
    },
    {
      "sub": "电力系统分析",
      "tec": "姜兴宇钱小毅",
      "week": "7-12周",
      "add": "教学楼C座212教务"
    },
    {
      "sub": "自动控制原理",
      "tec": "马艺骅",
      "week": "5-14周",
      "add": "教学楼C座210教务"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
